
import { Component, Prop, Vue } from 'vue-property-decorator'
import BillOfLadingForm from '@/components/DocumentGenerators/BillOfLading/Form.vue'
import { BillOfLading } from '@/models/BillOfLading'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'
import Icon from '@/components/Icon.vue'
import { namespace } from 'vuex-class'

const Viewport = namespace('viewport')

@Component({
	components: {
		BillOfLadingForm,
		Icon
	}
})
export default class LoadingBillNewDialog extends Vue {
	@Prop({ required: false, default: true })
	show!: boolean

	@Viewport.Getter('isMobile')
	isMobile

	isDocumentGenerating: boolean = false

	bol: BillOfLading | null = null

	async created() {
		this.bol = new BillOfLading()
	}

	async submitBillOfLading() {
		const form = this.$refs!.billOfLading! as BillOfLadingForm
		const valid = await form.validate()
		if (!valid) return

		this.isDocumentGenerating = true

		try {
			const savedBill = await form.submit()

			this.$emit('saved', {
				billId: savedBill.getApiId(),
				terminalId: savedBill.getStartLocation()?.getApiId() || null,
			})

			Notification.Success(i18n.t('loading_bill.success').toString())
		} finally {
			this.isDocumentGenerating = false
			this.$emit('close')
		}
	}
}
